
export class GC_Valid_T_Mobile {

    protected regex = '^1[0-9]{10}$';

    constructor() {
    }

    public validate(variable) {
        let ok = true;
        let objRegEx = new RegExp(this.regex);
        ok = objRegEx.test(variable);
        return ok;
    }

}
